/*
 *  Author: DL
 *  Date: 2020-12-03 09:53:55
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-03 15:39:49
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

export const dva = {
  config: {
    onError(err) {
      err.preventDefault();
      console.error(err.message);
    },
  },
};
